import { NpoPlayerEvent } from '../../types/events';
import { Container, TitleBar, PictureInPictureToggleButton, AirPlayToggleButton, CastToggleButton, SettingsToggleButton, FullscreenToggleButton, VolumeControlButton } from 'bitmovin-player-ui';
import { createSettingsPanel } from './settingspanel';
export function createTopBar(playerContext) {
    const npoPlayer = playerContext.npoplayer;
    const player = playerContext.player;
    const chromeCastButton = new CastToggleButton({
        disabled: true
    });
    const handleCastAvailable = () => {
        player?.off(NpoPlayerEvent.CastAvailable, handleCastAvailable);
        const remoteControlConfig = npoPlayer.playerConfig?.remotecontrol;
        if (player?.isCastAvailable() && remoteControlConfig.customReceiverConfig?.enable !== 'false') {
            chromeCastButton.enable();
        }
        else {
            chromeCastButton.disable();
        }
    };
    player?.on(NpoPlayerEvent.CastAvailable, handleCastAvailable);
    const settingsPanel = createSettingsPanel(npoPlayer);
    return new TitleBar({
        components: [
            new Container({
                components: [
                    new PictureInPictureToggleButton(),
                    new AirPlayToggleButton(),
                    chromeCastButton,
                    new SettingsToggleButton({ settingsPanel }),
                    settingsPanel,
                    new FullscreenToggleButton(),
                    new VolumeControlButton({
                        vertical: true
                    })
                ],
                cssClasses: ['controlbar-top', 'controlbar-small']
            })
        ],
        cssClasses: ['titlebar-small']
    });
}
